export default function PHP_sin() {
  return (
    <div>
      <h1>PHP_sin</h1>
    </div>
  );
}
